/**
 * Created by mohameds on 22/7/19.
 */
import React from 'react';
import loadingGIF from "../../public/assets/images/loading.gif";
import quote_background from "../../public/assets/images/agencyMonitor/bg-core-quote-min.jpeg";
import {MonitorConst} from "./Constants";

export const MonitorPageHOC = (WrappedComponent) => (
    class extends React.PureComponent {
        state = {
            pageData: {},
            loading: false
        };
        componentDidMount = () => {
            this.setState({loading: true}, () => {
                this.getPageData()
            })

        };
        componentDidUpdate = (prevProps) => {
            if (prevProps.keyValue !== this.props.keyValue) {
                this.getPageData();
            }
        };
        getPageData = async() => {
            try {
                let res = await this.props.actions.MonitorPage.getIndividualPageData(
                    this.props.pageObj);
                if (res) {
                    this.setState({
                        pageData: this.props.agencyMonitor.individualPageData
                    })
                }
            }
            catch (error) {
                console.log(error);
            }
            this.setState({loading: false});
        };
        render = () => {
            const {loading, pageData} =this.state;
            const {settings} = this.props;
            {
                return loading ?
                    <div className="text-center" style={{position: 'relative', top: '30%'}}>
                        <img src={loadingGIF} alt="loading..." width="64"/>
                    </div> :
                    MonitorConst.category.SPECIAL_OCCASION === pageData.category ?
                        <div className="container-fluid text-center h-100">
                            <img className="static-border-image" 
                                style={settings && settings.show_header ? {}: {height: '100%'}}
                                src={pageData.banner ? pageData.banner : quote_background}/>
                            <WrappedComponent {...this.props} pageData={pageData}/>
                        </div>
                    :
                        <WrappedComponent {...this.props} pageData={pageData}/>
            }
        }
    }
)


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/MonitorPageHOC.js